import 'assets/fonts/font-styles.css';
import 'styles/index.css';
import 'styles/animations.css';

import type { GatsbyBrowser } from 'gatsby';

// Force forward navigation to a new page to start at the top. Gatsby's own scroll-to-top
// is animated by the global `html { scroll-behavior: smooth }` (src/styles/index.css) and
// stalls mid-page when interrupted by hydration; returning false lets us reset instantly.
// We bail out (return true = Gatsby default) for hash anchors, same-page nav, and
// back/forward so those keep their normal scroll behavior.
export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps,
  prevRouterProps,
  getSavedScrollPosition,
}) => {
  const { location } = routerProps;
  const prevPath = prevRouterProps?.location?.pathname;

  // Hash anchors → let the existing hash handlers manage the scroll.
  if (location.hash) {
    return true;
  }

  // Same-page navigation (pagination/filter query-param changes) → don't reset scroll.
  if (prevPath !== undefined && location.pathname === prevPath) {
    return true;
  }

  // Back/forward to a previously-scrolled page → let Gatsby restore the saved position.
  const [, savedScrollY] = getSavedScrollPosition(location) as [number, number];
  if (savedScrollY > 0) {
    return true;
  }

  // Forward nav to a new page → reset instantly. ('instant' is cast: the TS lib's
  // ScrollBehavior omits it, but it's valid per spec and overrides scroll-behavior: smooth.)
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });

  return false;
};
